import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledGrid = styled.dl`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 18px 24px;
  margin: 0;

  dt {
    margin-bottom: 4px;
    font-size: 12px;
    color: var(--dimGray);
  }

  dd {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: var(--textColor);
    overflow-wrap: anywhere;
  }
`;

/**
 * Grid of label / value pairs used in the detail pages.
 * @component
 * @param {Object} props - The component props.
 * @param {Object[]} props.items - Items: { label, content }.
 * @returns {JSX.Element} - The InfoGrid component.
 */
export const InfoGrid = ({ items }) => (
  <StyledGrid>
    {items.map(({ label, content }) => (
      <div key={label}>
        <dt>{label}</dt>
        <dd>{content || '-'}</dd>
      </div>
    ))}
  </StyledGrid>
);

InfoGrid.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      content: PropTypes.node
    })
  ).isRequired
};
